import { TOGGLE_MENU } from '../constants/actions'

export const toggleSideBarAction = () => ({
  type: TOGGLE_MENU,
})
